module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "350px",
      "scrollable": ""
    },
    model: {
      value: (_vm.shown),
      callback: function($$v) {
        _vm.shown = $$v
      },
      expression: "shown"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.$t('tagger.title')))]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "tagger",
    staticStyle: {
      "height": "400px"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": _vm.$t('tagger.addTag')
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right"
  }, [_c('v-btn', {
    attrs: {
      "loading": _vm.isBusy
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.add($event)
      }
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v(_vm._s(_vm.$t('tagger.add')))], 1)], 1)], 1), _vm._v(" "), _vm._l((_vm.items), function(tag, i) {
    return _c('v-checkbox', {
      key: tag.tagName,
      staticClass: "my-0 py-0",
      attrs: {
        "label": tag.tagName,
        "value": i,
        "hide-details": ""
      },
      model: {
        value: (_vm.indexes),
        callback: function($$v) {
          _vm.indexes = $$v
        },
        expression: "indexes"
      }
    })
  })], 2), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "red--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.shown = false
      }
    }
  }, [_vm._v("Zrušit")]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.save($event)
      }
    }
  }, [_vm._v("Uložit")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ba8cb06","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tagger.vue
// module id = 1063
// module chunks = 1